import React from 'react';
import MarkerDescription from "./MarkerDescription";
import PropTypes from 'prop-types';

class MarkersList extends React.PureComponent {
  render() {
    return (
      <div className="MarkersList">
        {this.props.markers.map((l, i) => (
          <MarkerDescription
            key={i}
            marker={l}
            active={Boolean(this.props.activeMarker) && l.ID === this.props.activeMarker.ID}
            onClick={() => this.props.setActiveMarker(l)}
          />

        ))}
      </div>
    );
  }
}

MarkersList.propTypes = {
  markers: PropTypes.array.isRequired,
  activeMarker: PropTypes.object,
  setActiveMarker: PropTypes.func.isRequired,
};

export default MarkersList;
